"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
Object.defineProperty(exports, "wrapPageElement", {
  enumerable: true,
  get: function get() {
    return _userway["default"];
  }
});
var _userway = _interopRequireDefault(require("./userway"));